<template>
    <div id="verified">
        <div class="card-other">
            <div class="main">
                <div class="bindPhone">绑定手机号</div>
                <van-cell-group>
                    <van-field 
                        v-model="verifiedInfo.userPhone"
                        maxlength="11"
                        clearable
                        placeholder="请输入收货手机号码" 
                    >
                    <div slot="button" type="primary" size="small" 
                        :disabled="smsFlag" class="codeBtn" @click="getSmsCode">{{ btnTxt }}</div>
                    </van-field> 
                    <van-field
                        v-model="verifiedInfo.smsCode"
                        clearable
                        maxlength="6"
                        placeholder="请输入验证码" 
                        >
                       
                    </van-field>
                </van-cell-group>
                <div class="btnOuter">
                    <mt-button type="primary" size="large" @click.prevent="sureVerifiedHandler">绑定手机号</mt-button>
                </div>        
            </div>
        </div>
    </div>
</template>
<script>
import {wxRequest, verified} from '@/api/user'
import { Dialog, Toast } from 'vant';
export default {
    data(){
        return {
             recordLoginText:localStorage.getItem('recordLoginText'),
             leshuaPay:localStorage.getItem('leshuaPay'),
            verifiedInfo: {
                iccid: localStorage.getItem('iccid'),
                name: '张三',
                userPhone: '',
                idcard: '411529199920206952',
                smsCode: '',
                isFirst: 0,
            },
            btnTxt: '发送验证码',
            bindFlags: false,
            isFirst: 0
        }
    },
    methods: {
          getSmsCode(){
            if(this.btnTxt !== '发送验证码') return
            const rulut = this.verifiedInfo.userPhone //加密
            var data = {
                userPhone: rulut
            }
            wxRequest("bindPhone/sms/code", data, "post").then(res => {
                if(res.data.code == 200){
                    var n = 60;
                    this.btnTxt = '重新发送' + n +'s';
                    let timer = window.setInterval(() => {   
                        n--;                     
                        this.btnTxt = '重新发送' + n +'s';
                        if(n < 1){
                            window.clearInterval(timer);
                            this.btnTxt = '发送验证码';
                        }
                    },1000)
                }else{
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
        getVerifiedInfoHandler(){            
            var data = {
                iccid: localStorage.getItem('iccid')
            }
            wxRequest('bindPhone/phone/info/iccid', data, 'post').then(res => {
                if(res.data.code == 200 && res.data.data){
                    for(var key in this.verifiedInfo){
                        this.verifiedInfo[key] = res.data.data[key];
                    }
                }
            })
        },
        sureVerifiedHandler(){
            wxRequest("bindPhone/phone", this.verifiedInfo, "post").then(res => {
                if(res.data.code == 200){
                    this.$router.push('/user/home')
                }else if(res.data.code == 777){
                    Dialog.alert({message: res.data.message,}).then(() => {//跳转到支付实名费用
                        this.isFirst = 2;
                        this.userPhone = '';
                        this.idcard = '';
                        this.name = '';
                    });
                }else {
                    this.$messagebox.alert(res.data.message);
                }
            })
        },
        //支付实名
        payRealName(){
            let fd = new FormData();
            fd.append("iccid", this.verifiedInfo.iccid);
            let _this = this;
            wxRequest('order/bind/phone', fd, 'post').then(res => {
               if(this.leshuaPay==1){
                 window.location.href=res.data.data.jspay_url;
               }else{
                    let param = res.data.data.param;        
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', param,
                    function(res){
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            window.location.href = 'http://10086.sm.iot000.cn'
                        } 
                    }
                );
               }
            })
        }
    },
    created(){
       this.getVerifiedInfoHandler();
       
    },

    mounted(){
        this.verifiedInfo.iccid = this.$route.query.iccid?this.$route.query.iccid:localStorage.getItem('iccid');
        wxRequest("bindPhone/state", {iccid: this.verifiedInfo.iccid}, "post").then(res => {
            if(res.data.code == 200){
                let result = res.data.data;
                if(result.bindState == 2){
                    this.isFirst = result.isFirst;
                }else {
                    this.disabledFlag = true;
                }
            }else{
                Dialog.alert({title: '提示', message:res.data.message});
            }
        })
        if(this.isFirst == 2){
            Dialog({ message: '尊敬的用户，您当前有未支付的实名失败订单，请你优化支付完订单信息，再重新登录实名认证。' });
        }
    },
     computed: {
        bindFlag(){
            if(this.verifiedInfo.userPhone.length == 11){                
                return false;
            }else{                
                return true;
            }
        },
        smsFlag(){
            if(this.verifiedInfo.userPhone.length == 11 && this.verifiedInfo.btnTxt == '发送验证码'){
                return false;
            }else{
                return true;
            }
        },

    },
}
</script>
<style lang="less">
.codeBtn {
    float: right;
    margin-top: 2px;
    color: #26a2ff;
}
.bindPhone{
    font-size:20px;
    font-weight: bold;
    padding:30px 10px;
}
#verified {
    height: 100%;
    h4 {
        color: #fff;
        font-size: 10px;
        background: #26a2ff;
        line-height: 1.5em;
        padding: 6px 3%;
    }
    .main {
        height: calc(100% - 48px);
        padding: 0 4%;
        form{
            height: 100%;
        }
        .line {
            border-bottom: 1px solid #e5e5e5;
        }
        // .many {
        //     display: flex;
        //     justify-content: space-between;
        //     label {
        //         display: block;
        //         line-height: 36px;
        //     }
        //     .uploadOuter {
        //         position: relative;
        //         display: flex;
        //         justify-content: center;
        //         align-items: center;
        //         width: 48%;
        //         height: 100px;
        //         border: 1px dashed #e5e5e5;
        //         box-sizing: border-box;
        //         input[type=file] {
        //             position: absolute;
        //             top: 0;
        //             width: 0;
        //             width: 100%;
        //             height: 100%;
        //             opacity: 0;
        //         }                
        //         img {
        //             width: 100%;
        //             height: 100%;
        //         }
        //     }
        // }
        // .title {
        //     line-height: 28px;
        //     margin-top: 10px;
        // }
        .btnOuter {
            // display: flex;
            // align-items: center;
            // height: calc(100% - 424px;)

            margin-top: 30px;
        }
    }


    .card-dianxin{
        width: 100%;
        height: 100%;
        h1{
            font-size: 14px;
            background: #fff;
            line-height: 1.5em;
            padding: 6px 3%;
        }
        .dianxin-iframe{
            width: 100%;
            height: 100%;
        }
    }

    .card-other{
        width: 100%;
        height: 100%;
    }
    input.van-field__control{
        padding-left: 5px;
        line-height: 24px;
    }
}
</style>
